import { createLoader } from '@meteor/data-hooks';
import { withAuth } from '../../user';
import { organizationClient } from '../client';

export let organizationMembersLoader = createLoader({
  name: 'organizationMembers',
  fetch: (i: { organizationId: string }) =>
    withAuth(() => organizationClient.organizationMember.list(i)),
  mutators: {
    update: (
      i: {
        organizationMemberId: string;
        role: 'member' | 'admin';
      },
      { input: { organizationId } }
    ) =>
      withAuth(() =>
        organizationClient.organizationMember.update({
          organizationId,
          ...i
        })
      ),

    delete: (i: { organizationMemberId: string }, { input: { organizationId } }) =>
      withAuth(() =>
        organizationClient.organizationMember.delete({
          organizationId,
          ...i
        })
      )
  }
});

export let useOrganizationMembers = (organizationId: string | null | undefined) => {
  let member = organizationMembersLoader.use(organizationId ? { organizationId } : null);

  return {
    ...member,
    updateMutator: member.useMutator('update'),
    deleteMutator: member.useMutator('delete')
  };
};
